<template>
  <ul class="dimensions">
    <li class="dimensions__item"><b>Width</b> {{ dimensions.width }}mm</li>
    <li class="dimensions__item"><b>Depth</b> {{ dimensions.depth }}mm</li>
    <li class="dimensions__item"><b>Height</b> {{ dimensions.height }}mm</li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['parts', 'configuration']),
    dimensions() {
      let width = 0;
      let depth = 0;
      let height = 0;

      this.parts.forEach((part) => {
        if (this.configuration.indexOf(part.id) !== -1 && part.width) {
          width += part.width;
          depth = Math.max(depth, part.depth);
          height = Math.max(height, part.height);
        }
      });

      return { width, depth, height };
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.dimensions {
  position: absolute;
  bottom: 325px;
  right: 0;
  list-style: none;

  &__item {
    display: inline-block;
    margin-right: 40px;
    color: #A9A9A9;
    font-weight: 300;

    b {
      font-weight: $t_medium;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dimensions.vue